import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import React from 'react'
import ReactDOM from 'react-dom/client'

import { App } from './App'

// Import styles
import './app/globals.css'
import './styles/styles.css'

// Configure NProgress (replacement for nextjs-toploader)
NProgress.configure({
  showSpinner: false,
  minimum: 0.3,
  easing: 'ease',
  speed: 800,
})

// Initialize the app
const container = document.getElementById('root')
if (!container) {
  throw new Error('Root element not found')
}

const root = ReactDOM.createRoot(container)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
